import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { Stack, TextareaAutosize } from "@mui/material";
import { styled } from "@mui/system";
import FormFieldLabel from "./FormFieldLabel";
import { FieldConfig } from "../../types/forms";

// Styled TextareaAutosize component
const StyledTextareaAutosize = styled(TextareaAutosize)({
  width: "100%",
  outline: "none",
  padding: "8px",
  border: "1px solid #E5E5E5",
  borderRadius: "12px",
  minHeight: "32px",
  overflowY: "auto",
  resize: "none",
  color: "#21232C",
  "&:focus": {
    outline: "none",
  },
});

const CustomTextArea = <T extends FieldValues, U extends FieldValues = T>({
  name,
  label = "",
  rows,
  control,
  onChange,
  customClassName = "",
  required,
  placeholder,
}: FieldConfig<T, U>) => {
  return (
    <Controller
      name={name!}
      control={control}
      render={({ field }) => (
        <Stack className={"flex-col gap-2"}>
          {label && <FormFieldLabel label={label} required={required} />}
          {rows && (
            <StyledTextareaAutosize
              className={`${customClassName} custom-scrollbar`}
              minRows={rows}
              placeholder={placeholder}
              onChange={(e) => {
                field.onChange(e.target.value);
                onChange?.();
              }}
              value={field.value ?? ""}
              sx={{
                padding: { xs: "8px 10px", sm: "16px 21px" },
                paddingLeft: "auto",
                fontSize: { xs: "14px" },
              }}
            />
          )}
        </Stack>
      )}
    />
  );
};

export default CustomTextArea;
